import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

import Loading from '../Loading';

import styles from '../../styles/Settings.module.css';

const DataControls = ({ closeModal, userId }) => {
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(false);

    const [confirmDelete, setConfirmDelete] = React.useState(false);

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const handleDeleteAccount = (userIdForDelete) => {
        const token = localStorage.getItem('token');
        axios.put(`/api/block-unblock-acc?userId=${userIdForDelete}`, {}, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            handleLogout();
            setLoading(false);
        })
        .catch(err => {
            console.error('Ошибка системы при удалении учётной записи '+err);
            setWarning('Ошибка системы при удалении учётной записи: '+err.response.data || 'Ошибка сети.');
            setLoading(false);
        });
    }

    const handleDeleteButtonClick = () => {
        if (confirmDelete) {
            handleDeleteAccount(userId);
        } else {
            setConfirmDelete(true);
        }
    }
    
    return (
        <>
            <div className={styles.openSectionHeader}>
                <h3>Панель управления</h3>
            </div>
            <div className={styles.openSectionMain}>
                {loading ? <Loading /> : 
                    warning ? <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{warning}</a>
                    : 
                    <>                             
                        <div className={styles.settingLine}>
                            <a className={styles.settingLabel}>Изменить пароль</a>
                            <Link to='/safety/change-password' type='button' className='button' onClick={() => {closeModal()}}>Изменить</Link>
                        </div>
                        <div className={styles.settingLine} style={{marginTop: '30px'}}>
                            <a className={styles.settingLabel}>Деактивировать учётную запись</a>
                            <a className='description'>Функция временно отключена в целях безопасности</a>
                            {/* <button type='button' className='button red' style={{height: '40px'}} onClick={handleDeleteButtonClick}>
                                {confirmDelete ? 'Подтвердить' : 'Деактивировать'}
                            </button> */}
                        </div>
                        <a className={styles.settingDescription}>Обратите внимание, что деактивация учётной записи не приводит к полному уничтожению всех связанных с ней данных. Это необходимо для соблюдения требований законодательства и обеспечения работоспособности системы.<br />После деактивации данные учётной записи больше не будут использоваться для отправки уведомлений по электронной почте или прикрепления вас к юридическим делам.<br /><br />За более подробной информацией о том, как используются ваши данные, посетите страницу "Пользовательское соглашение и политика конфиденциальности"</a>
                        <div className={styles.settingLine}>
                            <a className={styles.settingLabel}>Пользовательское соглашение и политика конфиденциальности</a>
                            <Link 
                                to='/legal/privacy-policy' 
                                className='button' 
                                style={{marginLeft: '10px'}}
                            >
                                Перейти
                            </Link>
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default DataControls;